<template>
  <div class="hkfi-search-wrap zIndex99">
    <div class="search-icon" v-on:click="triggerSearchModal($event)">
      <div class="hkfi-search-lens medium fs-16"></div>
    </div>
  </div>
</template>

<script>
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import { EVENT_CLICK_SEARCHICON } from "../helpers/analyticsEvents";
import utility from "../helpers/utility";

export default {
  name: "Search",
  components: {},
  props: ["moduleProps"],
  data() {
    return {
      tempProps: "data",
    };
  },
  methods: {
    triggerSearchModal(e) {
      // document.body.classList.add("body-stop-scroll-mobile");
      // this.$store.commit(keyMapsMutation.UPDATE_SHOW_SEARCH_MODAL, true);
      EVENT_CLICK_SEARCHICON({ positionWithinSection: 2 });
      utility.sendToSearchScreen();
    },
  },
};
</script>

<style></style>
